import { GET_CAR_BRAND_BEGIN, GET_CAR_BRAND_SUCCESS } from "./type";

const initialState = {
    items: [],
    loading: false
}
export const CarBrandReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_CAR_BRAND_BEGIN:
            return {
                ...state,
                loading: true
            }
        case GET_CAR_BRAND_SUCCESS:
            return action.payload
        default:
            return state
    }
};
